import React, { useState } from 'react';
import { X, BookOpen } from 'lucide-react';
import { markdownToHtml } from '../../utils/markdownToHtml';

/**
 * Guide popup modal for daily report — fetches and renders markdown guide.
 * Props: visible, onClose, accent (color string)
 */
const DailyReportGuideModal = ({ visible, onClose, accent }) => {
  const [content, setContent] = useState('');

  // Fetch guide content when becoming visible
  React.useEffect(() => {
    if (!visible) return;
    if (content) return;
    const fetchGuide = async () => {
      try {
        const res = await fetch('/kienthuc/huong-dan-bao-cao-ngay.md');
        if (res.ok) {
          const text = await res.text();
          if (text.trimStart().startsWith('<!') || text.trimStart().startsWith('<html')) {
            setContent('Không tìm thấy nội dung hướng dẫn.');
          } else {
            setContent(text);
          }
        } else {
          setContent('Không tìm thấy nội dung hướng dẫn.');
        }
      } catch { setContent('Lỗi tải hướng dẫn.'); }
    };
    fetchGuide();
  }, [visible, content]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-fade-in" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-md max-h-[80vh] overflow-hidden flex flex-col animate-slide-up" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h3 className="text-sm font-bold text-gray-800">📖 Hướng dẫn</h3>
          <button onClick={onClose} className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200">
            <X size={14} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-4 py-3 text-[13px] text-gray-700 leading-normal"
          dangerouslySetInnerHTML={{ __html: content ? markdownToHtml(content) : 'Đang tải...' }} />
      </div>
    </div>
  );
};

/** Guide trigger button */
export const GuideButton = ({ onClick, accent }) => (
  <button onClick={onClick} className="flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-semibold ml-auto"
    style={{ color: '#f59e0b', background: '#fef3c7' }}>
    <BookOpen size={12} /> Hướng dẫn
  </button>
);

export default DailyReportGuideModal;
